<div class="row mb-3">
  <div class="col-12">
    <h3>
      <span [attr.data-automation]="headingDataAutomation()">{{ heading() }}</span>
    </h3>
  </div>
</div>
